import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { IMailResult, mailErrorKey } from './mailModel';

/**
 * Текст ошибки почты (ТЗ 0122) на языке экрана: машинный код сервера →
 * `mail.errors.<CODE>`; незнакомый код — текст сервера, без него — общие
 * слова.
 */
export const useMailErrorText = () => {
  const { t } = useTranslation();
  return useCallback(
    (result: Pick<IMailResult, 'error' | 'errorCode'> | null | undefined) => {
      if (!result) return '';
      const key = mailErrorKey(result.errorCode);
      if (key) return t(key);
      return result.error || t('mail.errors.unknown');
    },
    [t],
  );
};
